import * as React from "react";
import Wrapper from "../../../components/Wrapper";
import TenantWrapper from "../../../components/TenantWrapper";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import title from "../../../components/title";
import { useNotifications } from "./useNotifications";
import NotificationHeader from "./NotificationHeader";
import NotificationCard from "./NotificationCard";
import { LoadingState, EmptyState, DeleteConfirmModal } from "./NotificationStates";
import "./notification.css";

export default function NotificationsPage() {
  title("Notifications");

  const open = useSelector((state) => state.sidebar.open);

  // This page is shared by every role, so it renders the layout that matches
  // the signed-in user instead of always using the landlord chrome.
  const userType = useSelector(
    (state) => state.validateUser?.UserValidate?.data?.user?.type
  );
  const Layout = userType === "tenant" ? TenantWrapper : Wrapper;

  const {
    notifications,
    allNotifications,
    loading,
    markingAll,
    markingId,
    deletingId,
    filter,
    setFilter,
    unreadCount,
    allRead,
    deleteConfirm,
    setDeleteConfirm,
    markOneAsRead,
    markAllAsRead,
    deleteNotification,
    deleteAll,
  } = useNotifications();

  const handleConfirmDelete = () => {
    if (deleteConfirm === "all") {
      deleteAll();
    } else {
      deleteNotification(deleteConfirm);
    }
  };

  return (
    <>
      <Layout open={open} />

      <div className={`notif-page ${open ? "sidebar-open" : "sidebar-closed"}`}>
        {/* Header */}
        <NotificationHeader
          unreadCount={unreadCount}
          totalCount={allNotifications.length}
          allRead={allRead}
          markingAll={markingAll}
          deletingAll={deletingId === "all"}
          filter={filter}
          setFilter={setFilter}
          onMarkAll={markAllAsRead}
          onDeleteAll={deleteAll}
          setDeleteConfirm={setDeleteConfirm}
        />

        {/* Body */}
        {loading ? (
          <LoadingState />
        ) : notifications.length === 0 ? (
          <EmptyState filter={filter} />
        ) : (
          <div className="notif-list">
            {notifications.map((item, index) => (
              <NotificationCard
                key={item.id}
                item={item}
                isMarkingId={markingId === item.id}
                isDeletingId={deletingId === item.id}
                onMarkRead={markOneAsRead}
                onDeleteConfirm={setDeleteConfirm}
                style={{ animationDelay: `${index * 0.04}s` }}
              />
            ))}
          </div>
        )}
      </div>

      {/* Delete Confirm Modal */}
      {deleteConfirm && (
        <DeleteConfirmModal
          id={deleteConfirm}
          onConfirm={handleConfirmDelete}
          onCancel={() => setDeleteConfirm(null)}
          loading={deletingId !== null}
        />
      )}

      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
      />
    </>
  );
}